import Vue from 'vue';
const Tab = () => import('./Tab.vue');
export default Vue.extend({
    components: { Tab },
    props: {
        value: {
            type: Number,
            default: 0,
        },
        items: {
            type: Array,
            default: () => [],
        },
        tabsClass: {
            type: String,
            default: '',
        },
        centerActive: {
            type: Boolean,
            default: false,
        },
        sticky: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        activeTab: 0,
    }),
    watch: {
        value: {
            handler(val) {
                this.activeTab = val;
            },
            immediate: true,
        },
        activeTab(val) {
            this.$emit('input', val);
            if (this.centerActive) {
                this.centerTab(val);
            }
        },
    },
    methods: {
        onTabSelected($event) {
            this.activeTab = $event;
            this.$emit('tab:change', $event);
        },
        centerTab(index) {
            var _a, _b;
            const tabList = this.$refs.tabList;
            const tabItem = (_b = (_a = this.$refs[`tabItem${index}`]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.$el;
            if (tabItem) {
                const left = tabItem.offsetLeft;
                const width = tabItem.offsetWidth;
                const parentWidth = tabList.offsetWidth;
                const position = left + width / 2 - parentWidth / 2;
                tabList.scrollTo({
                    left: position,
                    behavior: 'smooth',
                });
            }
        },
    },
});
